import React from 'react';
import SelectGenerico from '../selectGenerico/selectGenerico';
import InputGenerico from '../inputGenerico/inputGenerico';

interface TerceiroFormularioProps {
    formValues: {
        dmTipoAnuncio: boolean;
        cdCategoria: string;
        cdModelo: string;
        cdCondicao: string;
        nrAnunciada: string;
        [key: string]: any;
    };
    handleFieldChange: (field: string, value: any) => void;
    validacaoAtiva: boolean;
    categorias: { cdCategoria: string | number; nmCategoria: string; }[];
    modelos: { cdModelo: string | number; nmModelo: string; }[];
    condicoes: { cdCondicao: string | number; nmCondicao: string; }[];
}

const TerceiroFormulario: React.FC<TerceiroFormularioProps> = ({ formValues, handleFieldChange, validacaoAtiva, categorias, modelos, condicoes }) => {
    
    return (
        <>
            {formValues.dmTipoAnuncio === true && (
                <div className={`mt-3 estiloGeral subbloco02 shadow-sm p-3 bg-light rounded`}>
                    <SelectGenerico
                        opcoes={categorias && categorias.map((categoria) => ({
                            valor: categoria.cdCategoria,
                            rotulo: `${categoria.nmCategoria}`,
                        }))}
                        valorSelecionado={formValues.cdCategoria}
                        onChange={(value: string | number) => handleFieldChange('cdCategoria', value)}
                        label="Categoria"
                        opcaoPadrao='Selecione a categoria...'
                        classe={`form-select mt-0 dropdown-content  ${validacaoAtiva && !formValues.cdCategoria ? 'select-invalid' : ''}`}
                    />

                    <SelectGenerico
                        opcoes={modelos && modelos.map((modelo) => ({
                            valor: modelo.cdModelo,
                            rotulo: `${modelo.nmModelo}`,
                        }))}
                        valorSelecionado={formValues.cdModelo}
                        onChange={(value: string | number) => handleFieldChange('cdModelo', value)}
                        label="Modelo"
                        opcaoPadrao='Selecione o modelo...'
                        classe={`form-select mt-0 dropdown-content  ${validacaoAtiva && !formValues.cdModelo ? 'select-invalid' : ''}`}
                    />
                    <SelectGenerico
                        opcoes={condicoes && condicoes.map((condicao) => ({
                            valor: condicao.cdCondicao,
                            rotulo: `${condicao.nmCondicao}`,
                        }))}
                        valorSelecionado={formValues.cdCondicao}
                        onChange={(value: string | number) => handleFieldChange('cdCondicao', value)}
                        label="Condição"
                        opcaoPadrao='Selecione a condição...'
                        classe={`form-select mt-0 dropdown-content  ${validacaoAtiva && !formValues.cdCondicao ? 'select-invalid' : ''}`}
                    />
                    <InputGenerico
                        name="nrAnunciada"
                        value={formValues.nrAnunciada}
                        onChange={(event) => handleFieldChange(event.target.name, event.target.value)}
                        placeholder="informe a quantidade..."
                        type="number"
                        className={`form-control mt-0  ${validacaoAtiva && !formValues.nrAnunciada ? 'input-invalid' : ''}`}
                        label='Quantidade'
                        min='0'
                    />
                </div>
            )}
        </>
    );
}

export default TerceiroFormulario;
